var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton',_vm._g({attrs:{"label":_vm.buttonLabel,"icon-class":"fa fa-history","color":"btn-info","is-small":_vm.isSmall,"hide-label":_vm.hideLabel,"disabled":_vm.disabled}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }